import { REST_API } from '../../constants/restApiUrls';
import HttpConnection from '../../utils/http-connection';

/**
 * データを取得する
 *
 */
export async function getData(id) {
  const httpConnection = new HttpConnection();

  return httpConnection
    .getById(REST_API.SETTING.MAIL_MAGAZINE_DETAIL.MAIL_MAGAZINE_DETAIL, id)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
}

/**
 * 保存
 *
 */
export async function saveData(data) {
  const httpConnection = new HttpConnection();
  return httpConnection
    .post(REST_API.SETTING.MAIL_MAGAZINE_DETAIL.MAIL_MAGAZINE_DETAIL_SAVE, data)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
}

/**
 * メール送信
 *
 */
export async function sendMail(id) {
  const httpConnection = new HttpConnection();
  return httpConnection
    .post(REST_API.SETTING.MAIL_MAGAZINE_DETAIL.SEND_MAIL, id)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
}

/**
 * 確認依頼
 *
 */
export async function confirmRequest(id) {
  const httpConnection = new HttpConnection();
  return httpConnection
    .post(REST_API.SETTING.MAIL_MAGAZINE_DETAIL.CONFIRM_REQUEST, id)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
}
